/* eslint-disable @typescript-eslint/no-explicit-any */
import { NoLoadedAccountComponent } from './no-loaded-account.component'
import { Component, Input, TemplateRef } from '@angular/core'

/**
 * This is used in tests that depend on NoLoadedAccountComponent
 */
@Component({
  selector: 'hs-no-loaded-account',
  template: '<ng-template [ngTemplateOutlet]="content"></ng-template>',
})
export class MockNoLoadedAccountComponent
  implements Partial<NoLoadedAccountComponent>
{
  @Input() content: TemplateRef<any> | null = null
}
